import styled from '@emotion/styled';
import colors, { white, primaryBGDark } from '../../../theme/colors';
import { isDarkMode } from '../../../utils/helpers';
import breakpoints from '../../../theme/material/breakpoints';

interface ITutorialSectionSubheader {
  maxWidth?: number;
}

interface ITutorialSectionWrapper {
  marginBottom?: number;
  paddingTop?: number;
}

export const TutorialHeader = styled('h1')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    fontSize: 26,
    fontWeight: 600,
    margin: 0,
    padding: 0,
    letterSpacing: -0.52,
    color: colors[theme].black.tertiary,
  };
});

export const TutorialSectionWrapper = styled('div')(({ marginBottom, paddingTop }: ITutorialSectionWrapper) => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    marginBottom: marginBottom || 30,
    paddingTop,
    color: colors[theme].black.tertiary,
    [breakpoints.up(769)]: {
      marginBottom: 36,
      paddingTop: 0,
    },
  };
});

export const TutorialSectionProfileInfoWrapper = styled('div')(({ marginBottom }: ITutorialSectionWrapper) => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    marginBottom: marginBottom || 36,
    color: colors[theme].black.tertiary,
    [breakpoints.up(769)]: {
      marginBottom: 50,
    },
  };
});

export const TutorialSectionSubHeaderWrapper = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    marginBottom: 30,
    color: colors[theme].black.tertiary,
    [breakpoints.up(769)]: {
      marginBottom: 50,
    },
  };
});

export const TutorialSectionSubheader = styled('p')(({ maxWidth }: ITutorialSectionSubheader) => ({
  color: isDarkMode() ? '#AFB0B1' : white,
  maxWidth,
  [breakpoints.up(769)]: {
    maxWidth: '100%',
  },
}));

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const TutorialComponentContainer = styled('div')(() => ({
  flexShrink: 0,
  background: isDarkMode() ? primaryBGDark : 'linear-gradient(93deg, #10CBBB 0%, #2B8FD7 100%)',
  opacity: 0.96,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  color: white,
  padding: '48px 0px 140px 0px',
  zIndex: 1,
  overflow: 'hidden',
  transition: 'transform 0.5s ease',
  [breakpoints.up(769)]: {
    padding: '0px',
    zIndex: 997,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

export const IconDescription = styled('p')({
  letterSpacing: '-0.32px',
  fontSize: 16,
  fontWeight: 700,
  [breakpoints.up(769)]: {
    marginBottom: 0,
  },
});

export const TutorialSectionSwipeInfoWrapper = styled('div')({
  [breakpoints.up(769)]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '90px',
  },
});
